import { isSuperAdmin } from './userTypes';
import { isAdminOfEmployee, visibilityCheckBasedOnReportingLevel } from './utils';

export const employeeHasManagedUsers = (employee) =>
  Boolean(employee.managedUsersCount && employee.managedUsersCount > 0);

const isCompanyPlanOnboarding = (company) => company?.baseDetails.companyPlan === 'onboarding';

export const userCanViewAllTeamTabColumns = (user, employee) => {
  return (
    user.id === employee.id ||
    isSuperAdmin(user) ||
    isAdminOfEmployee(user, employee) ||
    visibilityCheckBasedOnReportingLevel(user, employee)
  );
};

export const canViewTeam = (employee, company) => {
  return employeeHasManagedUsers(employee) && !isCompanyPlanOnboarding(company);
};
